'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = wrapField;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _filterDOMProps = require('uniforms/filterDOMProps');

var _filterDOMProps2 = _interopRequireDefault(_filterDOMProps);

var _gridClassName = require('./gridClassName');

var _gridClassName2 = _interopRequireDefault(_gridClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function wrapField(_ref, children) {
    var checkboxes = _ref.checkboxes,
        className = _ref.className,
        disabled = _ref.disabled,
        error = _ref.error,
        errorMessage = _ref.errorMessage,
        grid = _ref.grid,
        help = _ref.help,
        helpClassName = _ref.helpClassName,
        id = _ref.id,
        inline = _ref.inline,
        inputClassName = _ref.inputClassName,
        inputRef = _ref.inputRef,
        label = _ref.label,
        required = _ref.required,
        rows = _ref.rows,
        showInlineError = _ref.showInlineError,
        transform = _ref.transform,
        wrapClassName = _ref.wrapClassName,
        props = (0, _objectWithoutProperties3.default)(_ref, ['checkboxes', 'className', 'disabled', 'error', 'errorMessage', 'grid', 'help', 'helpClassName', 'id', 'inline', 'inputClassName', 'inputRef', 'label', 'required', 'rows', 'showInlineError', 'transform', 'wrapClassName']);

    var hasWrap = !!(grid || wrapClassName);

    var blockError = !!(error && showInlineError) && _react2.default.createElement(
        'span',
        { className: 'form-text text-danger' },
        errorMessage
    );

    var blockHelp = !!help && _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('form-text', helpClassName || 'text-muted') },
        help
    );

    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({
            className: (0, _classnames2.default)(className, 'form-group', {
                'has-danger': error,
                disabled: disabled,
                required: required,
                row: grid
            })
        }, (0, _filterDOMProps2.default)(props)),
        label && _react2.default.createElement(
            'label',
            {
                htmlFor: id,
                className: (0, _classnames2.default)('form-control-label', // bootstrap4 < alpha6
                { 'col-form-label': grid }, // bootstrap4 > alpha5
                (0, _gridClassName2.default)(grid, 'label'))
            },
            label
        ),
        hasWrap && _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(wrapClassName, (0, _gridClassName2.default)(grid, 'input')) },
            children,
            blockHelp,
            blockError
        ),
        !hasWrap && children,
        !hasWrap && blockHelp,
        !hasWrap && blockError
    );
}


//////////////////
// WEBPACK FOOTER
// ./~/uniforms-bootstrap4/wrapField.js
// module id = 21
// module chunks = 0